import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  location: string;
};
const reviews: Review[] = [{
  initials: 'MD',
  quote: "J'ai planifié toutes mes interventions en une seule soirée. Maintenant chaque séance a un objectif clair et j'entre en cabinet en sachant exactement ce que nous allons faire.",
  name: 'Marie D.',
  location: 'Paris, France'
}, {
  initials: 'SL',
  quote: 'Mes patients ont progressé plus en deux mois qu\u2019en toute la saison précédente. Les progressions par niveaux sont exactement ce dont nous avions besoin.',
  name: 'Sophie L.',
  location: 'Lyon, France'
}, {
  initials: 'CT',
  quote: "Avant je passais des heures sur internet à chercher des idées. Maintenant j'ouvre le Protocole Clinique et j'ai tout ce qu'il me faut pour la semaine.",
  name: 'Camille T.',
  location: 'Bordeaux, France'
}, {
  initials: 'PR',
  quote: 'Les formulaires de suivi des patients ont tout changé. Mes échanges avec les familles sont maintenant professionnels et basés sur des données concrètes.',
  name: 'Pierre R.',
  location: 'Marseille, France'
}, {
  initials: 'EW',
  quote: 'En tant que praticienne débutante, je me sentais complètement dépassée. Le Protocole Clinique m\u2019a fourni un système complet dès le premier jour. Ma confiance en cabinet a doublé.',
  name: 'Emma W.',
  location: 'Toulouse, France'
}, {
  initials: 'AB',
  quote: 'Le système d\u2019intervention en fonctions exécutives est exceptionnel. Mes patients DYS progressent avec une logique claire et les familles voient enfin la différence.',
  name: 'Arun B.',
  location: 'Strasbourg, France'
}];
export function Reviews() {
  return <section className="w-full bg-black px-4 py-20" data-id="element-198">
      <div className="mx-auto max-w-6xl" data-id="element-199">
        <Reveal data-id="element-200">
          <div className="text-center" data-id="element-201">
            <h2 className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-202">
              Ce que disent les professionnels
            </h2>
            <p className="mt-3 font-semibold text-gold" data-id="element-203">
              ⭐⭐⭐⭐⭐ 4,9/5 · Plus de 500 professionnels dans le monde
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-204">
          {reviews.map((r, i) => <Reveal key={r.name} delay={i % 3 * 0.07} data-id="element-205">
              <figure className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6" data-id="element-206">
                <div className="flex items-center gap-3" data-id="element-207">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15 text-sm font-bold text-gold" data-id="element-208">
                    {r.initials}
                  </span>
                  <div className="text-gold" data-id="element-209">⭐⭐⭐⭐⭐</div>
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-white/80" data-id="element-210">
                  "{r.quote}"
                </blockquote>
                <figcaption className="mt-5" data-id="element-211">
                  <div className="font-bold text-white" data-id="element-212">{r.name}</div>
                  <div className="text-xs text-white/50" data-id="element-213">{r.location}</div>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}